import { timeframeByMillisecondsMap } from './timeframe-to-milliseconds.model';

export const timeframeToMilliseconds = (timeframe: string) => {
  const millisecondsFromMap = timeframeByMillisecondsMap[timeframe];

  if (millisecondsFromMap) {
    return millisecondsFromMap;
  }

  // Seconds timeframe
  if (timeframe.includes('S')) {
    return parseInt(timeframe) * 1000;
  }

  // Minutes timeframe
  if (/\d+$/.test(timeframe)) {
    return parseInt(timeframe) * 60 * 1000;
  }

  // Days timeframe
  if (timeframe.includes('D')) {
    return parseInt(timeframe) * 24 * 60 * 60 * 1000;
  }

  // Weeks timeframe
  if (timeframe.includes('W')) {
    return parseInt(timeframe) * 7 * 24 * 60 * 60 * 1000;
  }

  // Months timeframe
  if (timeframe.includes('M')) {
    return parseInt(timeframe) * 30 * 24 * 60 * 60 * 1000;
  }

  return;
};
